(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/assets/javascripts/utils.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  productMapping
} = svs.numbergames;
const {
  CONSTANTS
} = svs.numbergames.andra_chansen;
const isInPeriod = (lottoDrawNumber, startDrawNumber, endDrawNumber) => lottoDrawNumber >= startDrawNumber && lottoDrawNumber <= endDrawNumber;
const isBeforeJune20 = date => new Date(date).getTime() < Date.parse('2020-06-20');

const andraChansenDraw = () => svs.numbergames.andra_chansen.data.andraChansenDraw;

const isAndraChansen = draw => (draw === null || draw === void 0 ? void 0 : draw.drawTypeId) === CONSTANTS.DRAW_TYPE.ANDRA_CHANSEN;

const isAndraChansenPeriodic = draw => (draw === null || draw === void 0 ? void 0 : draw.drawTypeId) === CONSTANTS.DRAW_TYPE.ANDRA_CHANSEN_PERIODIC;

const startAndEndDraws = (draw, productId) => {
  var _draw$products;
  return draw === null || draw === void 0 || (_draw$products = draw.products) === null || _draw$products === void 0 ? void 0 : _draw$products.find(product => productMapping.isSameProduct(product.productId, productId));
};

const showBannerDateSmartness = draw => {
  if (draw) {
    const dayDifferance = dateFns.differenceInDays(new Date(draw.endDate), new Date());
    return dayDifferance < 22;
  }
};

const isInCurrentPeriod = (draw, lottoDraw) => {
  if (draw) {
    const drawNumbers = startAndEndDraws(draw, lottoDraw.productId);
    if (drawNumbers) {
      const {
        startDrawNumber,
        endDrawNumber
      } = drawNumbers;
      return isInPeriod(lottoDraw.drawNumber, startDrawNumber, endDrawNumber);
    }
  }
  return false;
};

const givesChances = _ref => {
  let {
    hasJoker,
    isSyndicate,
    isFraction,
    drawDate
  } = _ref;
  if (isSyndicate || isFraction) {
    if (drawDate && isBeforeJune20(drawDate)) {
      return false;
    }
  }
  return hasJoker;
};

const chancesPerLottoDraw = wager => givesChances(wager) ? wager.rowCount * (wager.hasLotto2 + 1) : 0;

const chancesPerWager = wager => {
  const chancesPerDraw = chancesPerLottoDraw(wager);
  const chancesPerWeek = chancesPerDraw * wager.numberOfDays;
  if (wager.isSubscription) {
    return chancesPerWeek;
  }
  return chancesPerWeek * wager.drawCount;
};

const chancesPerDrawType = (lottoDraws, wager) => {
  const draws = [];
  const chancesAndraChansen = chancesPerWager(_objectSpread(_objectSpread({}, wager), {}, {
    numberOfDays: lottoDraws.length,
    isSubscription: false
  }));
  if (chancesAndraChansen) {
    draws.push({
      chances: chancesAndraChansen
    });
  }
  return draws;
};
svs.numbergames.andra_chansen.utils = {
  andraChansenDraw,
  isAndraChansen,
  isAndraChansenPeriodic,
  startAndEndDraws,
  showBannerDateSmartness,
  isInCurrentPeriod,
  givesChances,
  chancesPerLottoDraw,
  chancesPerWager,
  chancesPerDrawType
};

 })(window);